import { SpotTagCopy } from "@mlb/react-patterns/dist/components/SpotTag/spotTag.style";
import COLORS from "@mlb/react-patterns/dist/style/universal.color";
import styled from "styled-components";
import { FollowRowContainer } from "../FollowRow/styles";
import { TeamFilterRowContainer } from "../TeamFilterRow/styles";
export var ListContainerContainer = styled.div.withConfig({
  displayName: "styles__ListContainerContainer",
  componentId: "sc-1cmpmu6-0"
})(["", ",", "{border-bottom:1px solid ", ";padding:20px;", "{font-size:17px;line-height:22px;}}"], FollowRowContainer, TeamFilterRowContainer, COLORS.mlbGrey2, SpotTagCopy);